var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.2 86",
    style: {
      enableBackground: "new 0 0 79.2 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6933D6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,46L61.5,80.2C55.4,92,36.2,84,42.1,72l2.3-4.8c1.5-3.2,1.1-6.8-0.6-9.5c-1.6-2.7-4.5-4.5-7.9-4.6l-3.4,0 c-0.6,0-1.3,0-1.9,0c-9.6-0.1-12.4-9.4-8.2-15.3l1.6-3.4c1.5-3.2,1.1-6.8-0.6-9.5c-1.6-2.7-4.5-4.5-7.9-4.6l-5.2,0 C-4,20.2-3.5,0,12.4,0l37.4,0c3.3,0,6,1.7,7.7,4.1c1.5,2.7,1.7,6.1,0.3,9.1l-9.7,19.7l22.2,0c3.3,0,6,1.7,7.7,4.1 C79.4,39.7,79.7,43,78.2,46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMBlue);
export default __webpack_public_path__ + "static/media/logo_m_blue.75c03346cad701c5345a4277ff7402c2.svg";
export { ForwardRef as ReactComponent };